export const REPORTER_SPOTLIGHT = 'reporter-spotlight' as const;
